import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Col,
  Row,
  Button,
  Select,
  Typography,
  Space,
  Radio,
  Tag,
} from "antd";
import { DownOutlined, EnvironmentOutlined } from "@ant-design/icons";
import ReactECharts from "echarts-for-react";
import EnergyDashboard from "./EnergyDashboard";
import DashSankey from "./DashSankey";
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../Common/APIConstants";
import { calculateDateRangeFromDate } from "../../Utils/DateConverstion";
import PowerDemand from "./PowerDemand";
import * as echarts from "echarts";
import NotAuthenticated from "../CommonScreens/NotAuthenicated";

const { Title, Text } = Typography;

const dataCards = [
  {
    meterId: 1,
    parameterID: 16,
    parameterLive: 0,
    parameterPercentage: 0,
    parameterTargetValue: "0",
    highThreshold: "0",
    parameterStatus: "Kvat Day",
    lowThreshold: "0",
  },
  {
    meterId: 1,
    parameterID: 16,
    parameterLive: 0,
    parameterPercentage: 0,
    parameterTargetValue: "0",
    highThreshold: "0",
    parameterStatus: "Kvat MTD",
    lowThreshold: "0",
  },
  {
    meterId: 1,
    parameterID: 16,
    parameterLive: 0,
    parameterPercentage: 0,
    parameterTargetValue: "0",
    highThreshold: "0",
    parameterStatus: "KVAT Live",
    lowThreshold: "0",
  },
  {
    meterId: 1,
    parameterID: 15,
    parameterLive: 0,
    parameterPercentage: 0,
    parameterTargetValue: "0",
    highThreshold: "0",
    parameterStatus: "KWT Live",
    lowThreshold: "0",
  },
  {
    meterId: 1,
    parameterID: 17,
    parameterLive: 0,
    parameterPercentage: 0,
    parameterTargetValue: "0",
    highThreshold: "0",
    parameterStatus: "KVART Live",
    lowThreshold: "0",
  },
  {
    meterId: 1,
    parameterID: 18,
    parameterLive: 0,
    parameterPercentage: 0,
    parameterTargetValue: "0",
    highThreshold: "0",
    parameterStatus: "PFT Live",
    lowThreshold: "0",
  },
  {
    meterId: 1,
    parameterID: 8,
    parameterLive: 0,
    parameterPercentage: 0,
    parameterTargetValue: "0",
    highThreshold: "0",
    parameterStatus: "VLLAvg Live",
    lowThreshold: "0",
  },
  {
    meterId: 1,
    parameterID: 12,
    parameterLive: 0,
    parameterPercentage: 0,
    parameterTargetValue: "0",
    highThreshold: "0",
    parameterStatus: "IAVG Live",
    lowThreshold: "0",
  },
  {
    meterId: 1,
    parameterID: 40,
    parameterLive: 0,
    parameterPercentage: 0,
    parameterTargetValue: "0",
    highThreshold: "0",
    parameterStatus: "V_THDAvg Live",
    lowThreshold: "0",
  },
  {
    meterId: 1,
    parameterID: 44,
    parameterLive: 0,
    parameterPercentage: 0,
    parameterTargetValue: "0",
    highThreshold: "0",
    parameterStatus: "I_THDAvg Live",
    lowThreshold: "0",
  },
];

const { Option } = Select;

const Dashboard = () => {
  const chartRef = useRef(null);
  let chartInstance = null;

  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const [mainDashboardData, setMainDashboardData] = useState([]);
  //console.log(color);
  const [activeTab, setActiveTab] = useState("1");
  //console.log(activeTab);
  const { makeRequest } = useStoreUpdaterWithAPI();

  const [selectedMeterId, setSelectedMeterId] = useState(null);
  const [meters, setMeters] = useState([]);
  const [chartData, setChartData] = useState();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    // Call every 1 minute (60000 ms)
    const intervalId = setInterval(setChartInputData, 60000);

    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, [activeTab]);
  useEffect(() => {
  const intervalId = setInterval(() => {
    const now = new Date();
    const minutes = now.getMinutes();
    console.log(minutes)

    // Check if minutes match 0, 15, 30, 45
    if ([0, 15, 30, 45].includes(minutes)) {
      setChartInputData2();
    }
  }, 60 * 1000); // check every 1 minute

  // Cleanup on unmount
  return () => clearInterval(intervalId);
}, [activeTab]);



  function createDemandChartOption(data) {
    if (!data || !data.length) return {};
    // console.log(data)

    // Normalize date to "YYYY-MM-DD HH:mm"
    const normalizeDate = (dateStr) => {
      const d = new Date(dateStr);
      return (
        d.getFullYear() +
        "-" +
        String(d.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(d.getDate()).padStart(2, "0") +
        " " +
        String(d.getHours()).padStart(2, "0") +
        ":" +
        String(d.getMinutes()).padStart(2, "0")
      );
    };

    // Remove duplicates
    const uniqueData = Array.from(
      new Map(data.map((item) => [normalizeDate(item.slotTo), item])).values()
    );

    // Extract X-axis labels
    const xAxisData = uniqueData.map((item) =>
      new Date(item.slotTo).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      })
    );

    // Extract Y-axis values
    const baseDemand = uniqueData.map((item) => item.minValue);
    const peakDemand = uniqueData.map((item) => item.maxvalue);
    const contractedDemand = uniqueData.map((item) => item.targetValue);

    // Theme colors
    const textColor = isdarkMode ? "#ffffff" : "#111827";
    const gridColor = isdarkMode ? "#4b5563" : "#d1d5db";
    const bgColor = isdarkMode ? "#111827" : "#ffffff"; // used for download background

    return {
      backgroundColor: "transparent", // keep UI transparent
      title: {
        text: ` ${uniqueData[0]?.meterName || ""}`,
        left: "center",
        textStyle: { color: textColor },
      },
      tooltip: {
        trigger: "axis",
        backgroundColor: isdarkMode ? "#1f2937" : "#f9fafb",
        textStyle: { color: textColor },
        borderColor: gridColor,
        formatter: (params) =>
          params
            .map((p) => `${p.marker} ${p.seriesName}: <b>${p.value}</b>`)
            .join("<br>"),
      },
      legend: {
        data: ["Base Demand", "Peak Demand", "Contracted Demand"],
        top: 30,
        textStyle: { color: textColor },
      },
      grid: {
        top: 80,
        left: 60,
        right: 40,
        bottom: 100,
      },
      xAxis: {
        type: "category",
        data: xAxisData,
        axisLabel: { rotate: 45, color: textColor },
        axisLine: { lineStyle: { color: textColor } },
      },
      yAxis: {
        type: "value",
        name: "KVA",
        nameTextStyle: { color: textColor },
        axisLabel: { color: textColor },
        axisLine: { lineStyle: { color: textColor } },
        splitLine: { lineStyle: { color: gridColor } },
      },
      toolbox: {
        show: true,
        right: 20,
        feature: {
          saveAsImage: {
            show: true,
            title: "Download",
            pixelRatio: 2,
            name: "demand-chart",
            backgroundColor: bgColor, 
          },
        },
      },
      series: [
        {
          name: "Base Demand",
          type: "line",
          data: baseDemand,
          smooth: true,
          lineStyle: { color: "#3b82f6", width: 2 },
          itemStyle: { color: "#3b82f6" },
        },
        {
          name: "Peak Demand",
          type: "line",
          data: peakDemand,
          smooth: true,
          lineStyle: { color: "#ef4444", width: 2 },
          itemStyle: { color: "#ef4444" },
        },
        {
          name: "Contracted Demand",
          type: "line",
          data: contractedDemand,
          smooth: true,
          lineStyle: { color: "#22c55e", width: 2 },
          itemStyle: { color: "#22c55e" },
        },
      ],
    };
  }

  const handleChange = (value) => {
    //console.log("Selected value:", value);
    setSelectedMeterId(value.value);
    localStorage.setItem("dashboardSelectedMeter", value.value);
  };
  useEffect(() => {
    //  Group Name
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_GET_DASHBOARD_METER_DETAILS}`,
    }).then((res) => {
      //console.log(res);
      if (res) {
        setMeters(res);
        setSelectedMeterId(res[0].autoID);
        //console.log(res[0].autoID);
        localStorage.setItem("dashboardSelectedMeter", res[0].autoID);
      }
    });

  }, []);
  const setChartInputData = () => {
    // setOpen(false);
    const selectedMeterId = localStorage.getItem("dashboardSelectedMeter");
    //console.log(selectedMeterId);

    const currentDate = new Date();
    // //console.log(currentDate);
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    // //console.log(from, to);

    const inputData = {
      meterAutoID: Number(selectedMeterId) || 1,
      FromDate: from,
      ToDate: to,
    };
    // //console.log(inputData);
    if (activeTab == 1) {
      getDashboardResponse(inputData);
    }
  };
  const setChartInputData2 = () => {
    // setOpen(false);
    const selectedMeterId = localStorage.getItem("dashboardSelectedMeter");
    //console.log(selectedMeterId);

    const currentDate = new Date();
    // //console.log(currentDate);
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    // //console.log(from, to);

    const inputData = {
      meterAutoID: Number(selectedMeterId) || 1,
      FromDate: from,
      ToDate: to,
    };
    // //console.log(inputData);
    if (activeTab == 1) {
      getDashboardPlantCurve(inputData);
    }
  };
  function reorderParameters(arr) {
    const order = { Daily: 1, Monthly: 2, Live: 3 };

    return arr.sort((a, b) => {
      return order[a.parameterType] - order[b.parameterType];
    });
  }
  const getDashboardResponse = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_DASHBOARD_POWER_DEMAND}?MeterAutoID=${inputData.meterAutoID}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      if (res && res.length) {
        //console.log(reorderParameters(res));
        setMainDashboardData(reorderParameters(res));
      } else {
        setMainDashboardData(dataCards);
      }
    });
  };
  const getDashboardPlantCurve = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_DASHBOARD_PLANT_CURVE_DATA}?MeterAutoID=${inputData.meterAutoID}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      const data = createDemandChartOption(res);
      //console.log(data);
      if (res) {
        setChartData(res);
      }
    });
  };

  useEffect(() => {
    if (!chartRef.current) return; // DOM not ready yet

    if (!chartInstance) {
      chartInstance = echarts.init(chartRef.current);
    }

    const safeChartData =
      chartData && chartData.length > 0
        ? chartData
        : [{ name: "No Data", value: 0 }];

    const option = createDemandChartOption(safeChartData);
    chartInstance.setOption(option);

    const resizeHandler = () => chartInstance.resize();
    window.addEventListener("resize", resizeHandler);

    return () => {
      if (chartInstance) {
        chartInstance.dispose();
        chartInstance = null;
      }
      window.removeEventListener("resize", resizeHandler);
    };
  }, [chartData, isdarkMode, activeTab]);


  useEffect(() => {
    if (selectedMeterId) {
      setChartInputData();
      setChartInputData2();
    }
  }, [selectedMeterId,activeTab]);

  //console.log(isdarkMode);
  return (
        <div
          style={{  paddingTop: 4 }}
          className={` ${open ? "blur-sm pointer-events-none" : ""}  p-1 `}
        >
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: 5 }}
          >
            <Title level={3} style={{ color: isdarkMode ? "white" : "black" }}>
              Dashboard
            </Title>
            {activeTab === "1" && (
              <Select
                value={selectedMeterId}
                onChange={handleChange}
                // style={{ width: 200 }}
                labelInValue
                placeholder="Select a group"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {meters.map((i) => (
                  <Option key={i.autoID} value={i.autoID}>
                    {i.meterName}
                  </Option>
                ))}
              </Select>
            )}
          </Row>

          <Space style={{ marginBottom: 0 }}>
            <Radio.Group
              value={activeTab}
              onChange={(e) => {
                setActiveTab(e.target.value);
              }}
              style={{ marginBottom: 16 }}
            >
                {/* <Radio.Button value="3">Energy Consumption</Radio.Button> */}
                {/* <Radio.Button value="4">Gas Consumption</Radio.Button> */}
              <Radio.Button value="1">Power Demand</Radio.Button>
              <Radio.Button value="2">Energy</Radio.Button>
              
            
            </Radio.Group>
          </Space>
          {activeTab === "1" && (
            <>
              <Title
                level={4}
                style={{ color: isdarkMode ? "white" : "black" }}
              >
                <div className="flex justify-between ">
                  <div className="">
                Power Demand
                  </div>
                 <Tag className="animated-tag mr-8">
                      <EnvironmentOutlined className="mr-1" />
                      Live
                    </Tag>
                </div>
              </Title>
              <Card
                className={`${isdarkMode ? "bg-transparent" : "bg-blue-50"} `}
              >
                <Row gutter={[16, 16]}>
                  <PowerDemand
                    dataCards={dataCards}
                    mainDashboardData={mainDashboardData}
                  />
                </Row>
              </Card>

              <Card
                style={{ marginTop: 24 }}
                className={`${isdarkMode ? "bg-transparent" : "bg-blue-50"} `}
                title={
                  <div className="flex justify-between">
                    <span className={isdarkMode ? "text-white" : "text-black"}>
                      Plant Load Curve
                    </span>
                    <Tag className="animated-tag">
                      <EnvironmentOutlined className="mr-1" />
                      Live
                    </Tag>
                  </div>
                }
              >

                <div
                  id="chart"
                  ref={chartRef}
                  style={{ width: "100%", height: 500 }}
                />
              </Card>
            </>
          )}
          {activeTab === "2" && <EnergyDashboard activeTab={activeTab} />}
          {activeTab === "3" && <DashSankey activeTab={activeTab} />}
          {activeTab === "4" && <DashSankey activeTab={activeTab} />}
        </div>
  );
};

export default Dashboard;
